import { render, staticRenderFns } from "./TotalEvaluateSelectColumn.vue?vue&type=template&id=cb189654&scoped=true"
import script from "./TotalEvaluateSelectColumn.vue?vue&type=script&lang=js"
export * from "./TotalEvaluateSelectColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb189654",
  null
  
)

export default component.exports